<style lang="scss" scoped>
.link {
  cursor: pointer;
}
.male-icon {
  color: $male;
}
.female-icon {
  color: $female;
}
</style>

<template>
  <td v-if="profile" :class="{ 'table-danger': profile.deleted_at !== null }">
    <a :href="link">
      <img height="45" width="45" class="rounded-circle mr-2 link" :src="src" />
      {{ profile.name }}
      <i v-if="profile.sex == 'männlich'" class="fas fa-mars male-icon"></i>
      <i
        v-else-if="profile.sex == 'weiblich'"
        class="fas fa-venus female-icon"
      ></i>
    </a>
  </td>
  <td v-else v-html="nullHtml"></td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
    props: ['model', 'content'],
    computed: {
      nullHtml() {
        return defaultNullHtml();
      },
      src () {
        return this.profile.primary_image === undefined ? '' : `${this.profile.primary_image.url}?width=45&height=45`;
      },
      link () {
        if (Laravel.user.roles.some(el => el.name === "agency_leader")){
          return `/customer/${this.profile.id}`;
        }
        else {
          return this.profile.is_fake ?
            `/fake/kartei/${this.profile.id}` :
            `/mitglieder/kartei/${this.profile.id}`;
        }
      },
      profile () {
        return this.content;

      }
    }
};
</script>
